module.exports = __webpack_public_path__ + "img/SMSUpdate.f5fed8d6.jpg";